export type Vehicle = {
  id: string;
  brand: string;
  model: string;
  year: number;
  price: number;
  mileage: number;
  transmission: "Automatic" | "Manual" | "Dual-Clutch";
  fuel: "Gasoline" | "Diesel" | "Hybrid" | "Electric";
  body: "Sedan" | "SUV" | "Coupe" | "Convertible" | "Wagon";
  condition: "New" | "Certified" | "Used";
  available: boolean;
  power: number;
  acceleration: number;
  topSpeed: number;
  drivetrain: string;
  color: string;
  image: string;
  gallery: string[];
  features: string[];
  description: string;
  tag?: string;
};

export const formatPrice = (n: number) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(n);

export const formatMiles = (n: number) =>
  n === 0 ? "0 mi" : new Intl.NumberFormat("en-US").format(n) + " mi";

export function uniqueSorted<T extends string>(values: T[]): T[] {
  return Array.from(new Set(values)).sort();
}

export const BODY_OPTIONS: Vehicle["body"][] = [
  "Sedan",
  "SUV",
  "Coupe",
  "Convertible",
  "Wagon",
];

export const FUEL_OPTIONS: Vehicle["fuel"][] = ["Gasoline", "Diesel", "Hybrid", "Electric"];

export const TRANSMISSION_OPTIONS: Vehicle["transmission"][] = [
  "Automatic",
  "Manual",
  "Dual-Clutch",
];

export const CONDITION_OPTIONS: Vehicle["condition"][] = ["New", "Certified", "Used"];
